/* eslint-disable import/prefer-default-export */
export const ecg = [
    { value: 'FC=    bpm ' },
    { value: 'FC=    bpm, Ritmo Sinusal ' },
    { value: 'FC=    bpm, Ritmo Sinusal, dentro dos limites da normalidade ' },
    { value: 'Alteração da repolarização ventricular ' },
    { value: 'Alteração da repolarização ventricular anterior ' },
    { value: 'Alteração da repolarização ventricular anterolateral ' },
    { value: 'Alteração da repolarização ventricular difusa ' },
    { value: 'Alteração da repolarização ventricular inferior ' },
    { value: 'Alteração da repolarização ventricular lateral ' },
    { value: 'Área Inativa Anterior ' },
    { value: 'Área Inativa Anterior Extensa ' },
    { value: 'Área Inativa Anterolateral ' },
    { value: 'Área Inativa Anterosseptal ' },
    { value: 'Área Inativa Inferior ' },
    { value: 'Área Inativa Lateral ' },
    { value: 'FC=    bpm, Arritmia Sinusal ' },
    { value: 'Ativação atrial retrógrada ' },
    { value: 'Atraso Final de condução intraventricular  à direita ' },
    { value: 'Atraso Final de condução intraventricular  à esquerda ' },
    { value: 'Bloqueio Atrioventricular 2:1 ' },
    { value: 'Bloqueio Atrioventricular de 1º grau ' },
    { value: 'Bloqueio Atrioventricular de 2º grau Tipo I ' },
    { value: 'Bloqueio Atrioventricular de 2º grau Tipo II ' },
    { value: 'Bloqueio Atrioventricular de Alto grau ' },
    { value: 'Bloqueio Atrioventricular Total ' },
    { value: 'Bloqueio Divisional Anteromedial Esquerdo ' },
    { value: 'Bloqueio Divisional Anterossuperior Esquerdo ' },
    { value: 'Bloqueio Divisional Inferior Direito ' },
    { value: 'Bloqueio Divisional Posteroinferior Esquerdo ' },
    { value: 'Bloqueio Divisional Superior Direito ' },
    { value: 'Bloqueio do Ramo Direito ' },
    { value: 'Bloqueio do Ramo Esquerdo ' },
    { value: 'Bloqueio Sinoatrial do Tipo I ' },
    { value: 'Bloqueio Sinoatrial Tipo II ' },
    { value: 'FC=    bpm, Bradicardia Sinusal ' },
    { value: 'Desvio de Eixo para direita ' },
    { value: 'Desvio de Eixo para esquerda ' },
    { value: 'Dissociação atrioventricular ' },
    { value: 'Eixo indeterminado ' },
    { value: 'Extrassístole Atrial ' },
    { value: 'Extrassístole Atrial Bloqueada ' },
    { value: 'Extrassístole Atrial com Aberrância de condução ' },
    { value: 'Extrassístole Juncional ' },
    { value: 'Extrassístole Supraventricular ' },
    { value: 'Extrassístole Supraventricular Isoladas ' },
    { value: 'Extrassístole Supraventricular Pareadas ' },
    { value: 'Extrassístole Ventricular ' },
    { value: 'Extrassístole Ventricular Bigeminadas ' },
    { value: 'Extrassístole Ventricular Isoladas ' },
    { value: 'Extrassístole Ventricular Monomórficas ' },
    { value: 'Extrassístole Ventricular Parassístole Ventricular ' },
    { value: 'Extrassístole Ventricular Pareadas ' },
    { value: 'Extrassístole Ventricular Polimórficas ' },
    { value: 'Fibrilação Atrial ' },
    { value: 'Flutter Atrial ' },
    { value: 'Intervalo QT curto ' },
    { value: 'Intervalo QT longo ' },
    { value: 'Marcapasso com falha de comando ' },
    { value: 'Marcapasso com falha de sensibilidade ' },
    { value: 'Padrão de repolarização precoce ' },
    { value: 'Padrão de repolarização precoce anterolateral ' },
    { value: 'Padrão de repolarização precoce inferior ' },
    { value: 'Parada Sinusal ' },
    { value: 'Pré-excitação ventricular ' },
    { value: 'Presença de isquemia anterior ' },
    { value: 'Presença de isquemia anterior extensa ' },
    { value: 'Presença de isquemia anterolateral ' },
    { value: 'Presença de Isquemia anterosseptal ' },
    { value: 'Presença de isquemia inferior ' },
    { value: 'Presença de isquemia lateral ' },
    { value: 'Ritmo atrial ectópico ' },
    { value: 'Ritmo atrial multifocal ' },
    { value: 'Ritmo de Marcapasso Cardíaco Artificial Atrial ' },
    { value: 'Ritmo de Marcapasso Cardíaco Artificial Atrioventricular ' },
    { value: 'Ritmo de Marcapasso Cardíaco Artificial Ventricular ' },
    { value: 'Ritmo idioventricular acelerado ' },
    { value: 'Ritmo idioventricular de escape ' },
    { value: 'Ritmo juncional ' },
    { value: 'Ritmo juncional de escape ' },
    { value: 'Sobrecarga Atrial Direita ' },
    { value: 'Sobrecarga Atrial Esquerda ' },
    { value: 'Sobrecarga Biatrial ' },
    { value: 'Sobrecarga Biventricular ' },
    { value: 'Sobrecarga Ventricular Direita ' },
    { value: 'Sobrecarga Ventricular Esquerda ' },
    { value: 'Taquicardia Atrial ' },
    { value: 'Taquicardia Atrial Multifocal ' },
    { value: 'Taquicardia por Reentrada Atrioventricular Antidrômica ' },
    { value: 'Taquicardia por Reentrada Atrioventricular Ortodrômica ' },
    { value: 'Taquicardia por Reentrada Nodal Atípica  Incomum ' },
    { value: 'Taquicardia por Reentrada Nodal comum ' },
    { value: 'Taquicardia Sinusal ' },
    { value: 'Taquicardia Supraventricular com Aberrância de condução ' },
    { value: 'Taquicardia Ventricular Monomórfica ' },
    { value: 'Taquicardia Ventricular Polimórfica ' },
    {
        value:
            'Ritmo sinusal, FC:   bpm. Ausência de alteração de repolarização; Ausência de sobrecarga ventricular. Conclusão: ELETROCARDIOGRAMA NORMAL.' +
            '\nAndré Davignon et al., “Normal ECG Standards for Infants and Children”, Pediatric Cardiology 1, no 2 (Feb 1980).',
    },
    {
        value:
            'Ritmo sinusal, FC:   bpm. Repolarização infantil; Ausência de sobrecarga ventricular. Conclusão: ELETROCARDIOGRAMA NORMAL PARA A IDADE.' +
            '\nAndré Davignon et al., “Normal ECG Standards for Infants and Children”, Pediatric Cardiology 1, no 2 (Feb 1980).',
    },
];